/* eslint-disable camelcase */
/**
 * @author Daniel Aguirre
 * @file saga.js
 * @description Components State Saga
 */

// Dependencies
import { put, call, takeLatest } from 'redux-saga/effects';

// Services
import componentsStateService from '@nephro/services/componentsState-service';

// Global actions
import { setResponse, setLoading } from '@nephro/redux/stores/app/actions';

// Constants
import {
  GET_NEPHRO_MASTER_STATE,
  GET_NEPHRO_AUTH_STATE,
  GET_NEPHRO_INTEGRATOR_STATE,
  GET_NEPHRO_CALENDAR_STATE,
  GET_NEPHRO_MEDIA_STATE,
  GET_NEPHRO_COMMON_STATE
} from './constants';

/**
 * Return the status based on the service call
 * @param {*} action - Action with payload data
 * @param {*} serviceCall - Service to call
 */
function* getResponse(action, serviceCall, serviceName) {
  yield put(setLoading(true));
  yield put(setResponse(false, false, false));
  const { callback } = action;

  try {
    const response = yield call(serviceCall);
    yield put(
      setResponse(
        'success',
        false,
        false,
        { ...response, ...{ serviceName } },
        callback
      )
    );
  } catch (err) {
    yield put(
      setResponse(
        'error',
        false,
        false,
        { ...err, ...{ serviceName } },
        callback
      )
    );
    // yield put(setResponse(false, false, false));
    yield put(setLoading(false));
  }
  yield put(setLoading(false));
}

/**
 * Call service to get Nephro Master State
 * @param { object } action - Action with payload data
 */
export function* getNephroMasterState(action) {
  yield getResponse(
    action,
    componentsStateService.getNephroMasterState,
    'NephroMaster'
  );
}

/**
 * Call service to get Nephro Auth State
 * @param { object } action - Action with payload data
 */
export function* getNephroAuthState(action) {
  yield getResponse(
    action,
    componentsStateService.getNephroAuthState,
    'NephroAuth'
  );
}

/**
 * call service to get Nephro IntegratorState State
 * @param { object } action - Action with payload data
 */
export function* getNephroIntegratorState(action) {
  yield getResponse(
    action,
    componentsStateService.getNephroIntegratorState,
    'ephroIntegrator'
  );
}
/**
 * call service to get Nephro CalendarState State
 * @param { object } action - Action with payload data
 */
export function* getNephroCalendarState(action) {
  yield getResponse(
    action,
    componentsStateService.getNephroCalendarState,
    'ephroCalendar'
  );
}
/**
 * call service to get Nephro MediaState State
 * @param { object } action - Action with payload data
 */
export function* getNephroMediaState(action) {
  yield getResponse(
    action,
    componentsStateService.getNephroMediaState,
    'ephroMedia'
  );
}
/**
 * call service to get Nephro CommonState State
 * @param { object } action - Action with payload data
 */
export function* getNephroCommonState(action) {
  yield getResponse(
    action,
    componentsStateService.getNephroCommonState,
    'ephroCommon'
  );
}

/**
 * Declare all component sagas
 */
export function* watchComponentsStateSaga() {
  yield takeLatest(GET_NEPHRO_MASTER_STATE, getNephroMasterState);
  yield takeLatest(GET_NEPHRO_AUTH_STATE, getNephroAuthState);
  yield takeLatest(GET_NEPHRO_INTEGRATOR_STATE, getNephroIntegratorState);
  yield takeLatest(GET_NEPHRO_CALENDAR_STATE, getNephroCalendarState);
  yield takeLatest(GET_NEPHRO_MEDIA_STATE, getNephroMediaState);
  yield takeLatest(GET_NEPHRO_COMMON_STATE, getNephroCommonState);
}
